/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import HeaderFilter from '../components/HeaderFilter'
import Overview from './container/Overview'
import ChartRow from './container/ChartRow'
import ServiceList from './container/ServiceList'
import { ServiceOverviewSearchProps } from '../components/typescript'
import useNavRegion from 'src/hooks/useNavRegion'
import { initSearch } from '../components/constant'
// 嵌入页面隐藏面包屑
const IS_TOP_WINDOW = window.self === window.top
const ServiceOverview: React.FC<{ className?: string }> = ({ className }) => {
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  // 控制台region
  const region = useNavRegion()

  return (
    <div className={className}>
      {IS_TOP_WINDOW ? (
        <MonitorCrumb breadArr={[{ title: _$('AI可观测') }, { title: _$('服务总览') }]} />
      ) : null}
      <Card title={_$('服务总览')}>
        <HeaderFilter value={filterSearch} onChange={setFilterSearch} />
        <Overview
          region={region}
          startTime={filterSearch?.time?.[0]}
          endTime={filterSearch?.time?.[1]}
        />
        <ChartRow
          region={region}
          startTime={filterSearch?.time?.[0]}
          endTime={filterSearch?.time?.[1]}
          aggregate={filterSearch?.aggregateType}
        />
        <ServiceList
          region={region}
          startTime={filterSearch?.time?.[0]}
          endTime={filterSearch?.time?.[1]}
        />
      </Card>
    </div>
  )
}

export default styled(ServiceOverview)`
  padding: 0 16px;
`
